import React from 'react';
import AccessSection from '../components/home/AccessSection';
import AudienceSection from '../components/home/AudienceSection';
import HeroSection from '../components/home/HeroSection';

function Home() {
  return (
    <>
      <HeroSection />
      <AudienceSection />
      <AccessSection />
    </>
  );
}

export default Home;
